import Card from "react-bootstrap/Card";
import './custom2.css';
import { ArrowDownCircleFill, ArrowRight, ArrowRightCircle, ArrowUpCircleFill, ClockHistory,ExclamationCircle, ExclamationCircleFill } from 'react-bootstrap-icons';
import React,{ReactBootstrap,useState, useEffect } from 'react';
import { Collapse } from "bootstrap"
import PurchaseChart from "./PurchaseChart";

function CollapseDemo({basket,id}) {
  var [toggle, setToggle] = useState(false);

  useEffect(() => {
        var myCollapse = document.getElementById(id)
        var bsCollapse = new Collapse(myCollapse, {toggle: false})
        toggle ? bsCollapse.show() : bsCollapse.hide()
      
  })

return (
  <div className="py-2">
      <button className="btn btn-info" style={{width:"170px"}} onClick={() => setToggle(toggle => !toggle)}>
         Purchase History {
           toggle ? <ArrowUpCircleFill color="black" size={16} style={{display:"unset"}} /> : <ArrowDownCircleFill color="black" size={16} style={{display:"unset"}}  />
         } 
      </button>
      <div className="collapsex" id={id} style={{visibility:"unset!important"}}>
       { toggle &&  <PurchaseChart outletCode={basket.outletCode} skuCode={basket.skuCode}/>
        }
      </div>
  </div>
)
}

export function SmartBasket({ basket }) {
    const data = "This is data from Child Component to the Parent Component."
    const ulStyle = { width: '100%', listStyleType: 'none',padding:'0px' }
    const liStyle = { color: 'black', fontSize: '16px', borderBottom: '1px solid #eee',padding:'10px',margin:"10px",bacground:"black" }
  
    const [basket1,setBasket]=useState(JSON.parse(JSON.stringify(basket)));
  
    const onclickIndex=(index)=>{
      basket1[index].isOpened = !basket1[index].isOpened;
      alert(index)
      setBasket(basket1);
    }
    return (
      
      <ul style={ulStyle}>
        {basket1.map((v, index) => {
          //v.true=false;
          return <li key={index} style={liStyle} className="card">
            {
              v.isOutCapacity && 
              <span style={{color:"red"}}><ExclamationCircleFill color="red" size={16} />  Out of purchase capacity</span>
            }
            <table className="cattable">
              <tr><th>SKU</th><th>Amount</th><th>Quantity</th><th>Relevance</th></tr>
              <tr><td>{v.skuCode}</td><td>{v.amount.toFixed(2)}</td><td>{v.quantity.toFixed(2)}</td><td>{v.relevance.toFixed(2)}</td></tr>
              <tr><CollapseDemo id={"collapse-"+index} basket={basket1[index]}/></tr>
            </table>
            
          </li>
        })}
      </ul>
      
    )
  }
  
  
  
  